import { fetchCTPartnerId } from "../../generalUtils/partnerIdConfigCT"

export interface FareCalendarPayload {
    queryContext: {
        startDate: string
        daysCount: number
        cabin: string
        origin: string
        destination: string
        paxTypeContext: {
            adultCount: number
            childCount: number
            infantCount: number
        }
    }
    demandContext: {
        partnerId: string
    }
}


export function buildFareCalendarRequest({
    startDate,
    daysCount,
    searchParams,
    partnerId
}: {
    startDate: string
    daysCount: number
    searchParams: any
    partnerId?: string
}): FareCalendarPayload {
    
    return {
        queryContext: {
            startDate: startDate,
            daysCount: daysCount,
            cabin: searchParams.class?.toUpperCase() || 'ECONOMY',
            origin: searchParams.from,
            destination: searchParams.to,
            paxTypeContext: {
                adultCount: Number(searchParams.adults) || 1,
                childCount: Number(searchParams.childs) || 0,
                infantCount: Number(searchParams.infants) || 0
            }
        },
        demandContext: {
            partnerId: partnerId || fetchCTPartnerId()
        }
    }
}
